import { inject, Injectable } from '@angular/core';
import { bannersToCarousel, HomeBannerDto } from '@models';
import { ICarouselSlide } from 'libs/ui/carousel/src/lib/carousel/interfaces/carousel-slide.interface';
import { map, Observable } from 'rxjs';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})
export class HomeBannersService {
  private readonly apiService = inject(ApiService);

  getHomeCarouselSlides(): Observable<ICarouselSlide[]> {
    return this.apiService.get<HomeBannerDto[]>('homepage-banners').pipe(map(bannersToCarousel));
  }
}
